import styles from './styles.module.scss';

import React from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';

import {Row, Col} from 'reactstrap';
import {ContentBox} from 'components/Contents';
import {LabelCountry} from 'components/Labels';
import MuiIcon from 'components/Icons/MuiIcon';

function SpecItem({title, description}) {
  return (
    <Col md="6">
      <Row>
        <Col tag="dt" sm="4">
          {title}:
        </Col>
        <Col tag="dd">{description}</Col>
      </Row>
    </Col>
  );
}

function Component(props) {
  const {
    link,
    className,
    certNumber,
    companyId,
    companyName,
    countryId,
    standardScheme,
    standardName,
  } = props;

  return (
    <ContentBox
      className={classNames(styles['search-item'], {
        [className]: !!className,
      })}
    >
      <Row>
        <Col>
          <div className="text-secondary">Certificate No.</div>

          <h5 className={styles['search-item__name']}>
            <Link to={link}>{certNumber}</Link>
          </h5>

          <Row tag="dl">
            <SpecItem
              title="Certified Entity"
              description={
                <Link to={`/certified-entity/${companyId}`}>{companyName}</Link>
              }
            />
            <SpecItem
              title="Location"
              description={
                <LabelCountry
                  className="text-secondary"
                  country_id={countryId}
                />
              }
            />
            <SpecItem title="Scheme" description={standardScheme} />
            <SpecItem title="Standard" description={standardName} />
          </Row>
        </Col>

        <Col xs="12" lg="auto" className="d-flex align-items-center">
          <Link to={link}>
            Learn More <MuiIcon name="arrow_forward" />
          </Link>
        </Col>
      </Row>
    </ContentBox>
  );
}

export default Component;
